import { render, staticRenderFns } from "./ScreenEvictionsList.vue?vue&type=template&id=c0a2ae4a&scoped=true&"
import script from "./ScreenEvictionsList.vue?vue&type=script&lang=js&"
export * from "./ScreenEvictionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a2ae4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VDataTable,VSwitch})
